/**
 * Shared Footer Component for Checkout Pages
 * Displays links to terms, privacy, and support
 */

import React from 'react';

export const CheckoutFooter: React.FC = () => {
  return (
    <div className="text-center mt-12 pt-8 border-t border-gray-300 dark:border-white/10">
      <div className="flex items-center justify-center space-x-6 text-sm text-kind-text-secondary">
        <button className="hover:text-kind-text-primary transition-colors">Terms of Service</button>
        <span>•</span>
        <button className="hover:text-kind-text-primary transition-colors">Privacy Policy</button>
        <span>•</span>
        <button className="hover:text-kind-text-primary transition-colors">Contact Support</button>
      </div>
    </div>
  );
};
